"use strict";
exports.__esModule = true;
var React = require("react");
var uuid_1 = require("uuid");
var GoogleMapContext_1 = require("../context/GoogleMapContext");
var operation_1 = require("../googlemap/operation");
var cluster_1 = require("../googlemap/cluster");
var googelMapInstance = function (props) {
    var mapId = React.useState(uuid_1.v4())[0];
    var _a = React.useContext(GoogleMapContext_1.GoogleMapContext), map = _a.map, setMap = _a.setMap, zoom = _a.zoom, setZoom = _a.setZoom, setBound = _a.setBound, children = _a.children, setChildren = _a.setChildren, setCenter = _a.setCenter, center = _a.center;
    var clusterMarkers = function () {
        // googleMapTextLabel
        var newChildren = props.children;
        if (!newChildren.map)
            newChildren = [newChildren];
        var nonGroupableMarkers = newChildren.filter(function (it) { return !(it.props.value >= 0); });
        var groupableMarkers = newChildren.filter(function (it) { return it.props.value; });
        var groupedMarkers = cluster_1.doClusterMarkers(map, groupableMarkers);
        var allMarkers = groupedMarkers.concat(nonGroupableMarkers);
        setChildren(allMarkers);
    };
    var onZoomed = function (zoom) {
        clusterMarkers();
    };
    // SDK Ready
    React.useEffect(function () {
        var newMap = operation_1.mapCreate(mapId);
        setTimeout(function () {
            setMap(newMap);
        }, 200);
    }, []);
    // Map Init
    React.useEffect(function () {
        if (!map)
            return;
        operation_1.mapCenter(map, props.center);
        operation_1.mapZoom(map, props.zoom);
        operation_1.mapListen(map, 'dragend', function () {
            var newCenter = operation_1.mapGetCenter(map);
            setCenter(newCenter);
            if (!props.onMoved)
                return;
            props.onMoved(newCenter);
        });
        operation_1.mapListen(map, 'zoom_changed', function () {
            setTimeout(function () {
                var zoom = operation_1.mapGetZoom(map);
                setZoom(zoom);
            }, 100);
        });
    }, [map]);
    React.useEffect(function () {
        if (onZoomed)
            onZoomed(zoom);
        if (props.onZoomed)
            props.onZoomed(zoom);
    }, [zoom]);
    React.useEffect(function () {
        clusterMarkers();
    }, [center]);
    // Prop changed
    React.useEffect(function () {
        if (!map)
            return;
        operation_1.mapCenter(map, props.center);
    }, [props.center]);
    React.useEffect(function () {
        if (!map)
            return;
        if (props.zoom >= 0) {
            operation_1.mapZoom(map, props.zoom);
            setZoom(props.zoom);
        }
        if (props.zoom === -1) {
            setBound(new google.maps.LatLngBounds());
            setZoom(props.zoom);
        }
        if (props.zoom === -2) {
            setBound(new google.maps.LatLngBounds());
            setZoom(props.zoom);
        }
    }, [props.zoom]);
    React.useEffect(function () {
        setChildren(props.children);
        clusterMarkers();
    }, [props.children]);
    var renderMap = function () {
        // rerender map
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { id: mapId, style: { width: '100%', height: '100%' } }),
            children ? children : null));
    };
    return renderMap();
};
exports.GoogelMapInstance = googelMapInstance;
